import React, { memo, Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import FileFormats from './Components/FileFormats'
import FiltersWrapperWithButtons from './Components/FiltersWrapperWithButtons'
import ModelType from './Components/ModelType'
import PolyCount from './Components/PolyCount/PolyCount'
import Price from './Components/Price/Price'
import RemainingFilters from './Components/RemainingFilters/LazyRemainingFilters'
import ResetFiltersAction from './Components/ResetFiltersAction'
import SortBy from './Components/SortBy'

function Filters({
  isSuggestionsVisible,
  extractingCoreStyles,
  isMobile,
  locale = 'en',
  subscriptionFlowEnabled = false,
}) {
  return (
    <div className={classnames(
      'listing-filters',
      isSuggestionsVisible && 'listing-filters--with-suggestions'
    )}
    >
      {!isMobile && (
        <Fragment>
          <FileFormats />
          <FiltersWrapperWithButtons type="pricing" />
          <Price locale={locale} />
          <ModelType />
          <FiltersWrapperWithButtons type="modelType" />
          <PolyCount locale={locale} />
          {!subscriptionFlowEnabled && (
            <FiltersWrapperWithButtons type="designers" />
          )}
          <RemainingFilters subscriptionFlowEnabled={subscriptionFlowEnabled} />
          <SortBy extractingCoreStyles={extractingCoreStyles} />
          <ResetFiltersAction />
        </Fragment>
      )}
    </div>
  )
}

Filters.propTypes = {
  isMobile: bool.isRequired,
  isSuggestionsVisible: bool.isRequired,
  extractingCoreStyles: bool.isRequired,
  subscriptionFlowEnabled: bool,
  locale: string,
}

export default memo(Filters)
